export default {
        name: 'Categories',
        data() {
        return{
            categories: null,
            category: null,
            message: '',
            error: null,
            search: ""
        }
        },
        methods: {
        getCategories: function(autoSelect){
            this.$http.get(this.$config.ApiUri + "/Discounts/Categories")
                .then((result) => {
                    this.categories = result.data;
                    if (autoSelect) {
                        if (this.categories.length > 0) {
                            this.selectCategory(this.categories[0]);
                        }
                    }
                }
            )
        },
        selectCategory: function(c) {
            this.category = c;
        },
        deleteCategory: function(){
                this.$http.delete(this.$config.ApiUri + "/Discounts/Categories/" + this.category.id)
                    .then(() => {
                        this.getCategories(true);
                        this.showMessage("Category deleted OK!");
                    }
                ).catch(() => { this.showError(); });
        },
        saveCategory: function(){
            if (this.category.id == null) {
                this.$http.post(this.$config.ApiUri + "/Discounts/Categories", this.category)
                    .then((result) => {
                        this.category = result.data;
                        this.getCategories(false);
                        this.showMessage("Category created OK!");
                    }
                ).catch(() => { this.showError(); });
            }
            else {
                this.$http.put(this.$config.ApiUri + "/Discounts/Categories/" + this.category.id, this.category)
                    .then((result) => {
                        this.category = result.data;
                        this.getCategories(false);
                        this.showMessage("Category saved OK!");
                    }
                ).catch(() => { this.showError(); });
            }
        },
        showMessage(message) {
            this.message = message;
            this.$bvModal.show('modMessage');
            setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
        },
        showError(message) {
            if (!message) { message = "Sorry, that didn't work, please contact Tris or Steve"; }
            this.message=message;
            this.$bvModal.show('modMessage');
            setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
        },
        newCategory() {
            this.category = { 
                "buttonTitle": "",
                "pageTitle": "",
                "providerFilters": "",
                "buttonImage": "",
                "pageImage": "",
                "active": true
            };
            this.actionType = null;
        },
        onImageSelected(e) {
            var file = e.target.files[0];
            this.fileName = file.name;
            this.getBase64(file);
        },
        getBase64(file) {
            var reader = new FileReader();
            reader.onload = (e) => {
                this.image = e.target.result.split(',')[1];
            };
            reader.readAsDataURL(file);
        },
        uploadImage(field) {
            console.log("uploading image for field " + field);
            this.$http.post(this.$config.ApiUri + "/CMS/Files/UploadRequests", { "content" : this.image, "fileName": this.fileName })
                .then((result) => {
                    if (field == "pageImage") this.category.pageImage = result.data.uri;
                    if (field == "buttonImage") this.category.buttonImage = result.data.uri;
                    alert("Image uploaded OK");
                }
            )
        },
      onLoad() {
          this.getCategories(true);
      }
    },
    mounted: function() { this.onLoad(); }
  }